import {AxiosError, AxiosResponse} from "axios";

interface Result {
    success: (response: AxiosResponse) => AxiosResponse,
    error: (error: AxiosError) => AxiosError|Promise<AxiosError>,
}

export default (): Result => {
    return {
        success: (response: AxiosResponse) => {
            return response
        },
        error: (err: AxiosError) => {
            return Promise.reject(err);
        }
    }
}

